import baseProps from "@/base_lib/data/props/base"

const bottomHistoryProps = {
    ...baseProps,
    title: {
        type: String,
        required: true,
        default: "",
    },
    loading: {
        type: Boolean,
        required: true,
        default: true,
    },
    items: {
        type: Array,
        required: true,
        default: () => [],
    },
    headerValues: {
        type: Array,
        required: false,
        default: () => [],
    },
    show: {
        type: Boolean,
        required: true,
        default: false,
    },
    errorMessage: {
        type: String,
        required: false,
        default: null,
    },
    downloadLoading: {
        type: Boolean,
        required: false,
        default: false,
    },
    downloadMessage: {
        type: String,
        required: false,
        default: "Please stand by",
    },
}

export default bottomHistoryProps
